export default __webpack_public_path__ + "static/media/dimos_alexandrias.2164ced6.png";